import * as React from 'react';
import { calculateToolboxHeight, setToolboxHeight, toolboxVerticalMargin } from '../viewstate';

export default function useToolboxState() {
    const toolboxRef = React.useRef<HTMLDivElement>(null);

    React.useLayoutEffect(() => {
        const setNewToolboxHeight = () => {
            const spaceForFeedbackButton = 20;
            const parentHeight =
                (toolboxRef?.current?.offsetParent?.clientHeight ?? calculateToolboxHeight()) -
                toolboxVerticalMargin * 2 -
                spaceForFeedbackButton;
            parentHeight && setToolboxHeight(parentHeight);
        };

        window.addEventListener('resize', setNewToolboxHeight);
        setNewToolboxHeight();
        return () => window.removeEventListener('resize', setNewToolboxHeight);
    }, [toolboxRef]);

    return {
        toolboxRef: toolboxRef,
    };
}
